import { makeStyles, Theme } from "@material-ui/core/styles";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import MailIcon from "@material-ui/icons/Mail";
import { PrimaryButton } from "../../../../../../../shared/Button/PrimaryButton";
import { tryInvitationCard } from "./functions";

export function InviteFriendsButton({ hasNoData }: { hasNoData?: boolean }) {
    const c = useStyles({ hasNoData });

    return (
        <div className={c.container}>
            <PrimaryButton
                className={c.button}
                startIcon={<MailIcon />}
                endIcon={<KeyboardArrowRightIcon />}
                onClick={tryInvitationCard}
            >
                Invite {!hasNoData && "More "}Friends
            </PrimaryButton>
        </div>
    );
}
const useStyles = makeStyles<Theme, { hasNoData?: boolean }>({
    container: ({ hasNoData }) => ({
        marginBottom: 10,
        marginTop: 5,
        paddingRight: 5,
        paddingLeft: 5,
        display: "flex",
        justifyContent: hasNoData ? "center" : "flex-end",
        alignItems: "center",
        width: "100%",
    }),
    button: {
        maxHeight: 30,
        minHeight: 30,
        fontSize: "15px !important",
        lineHeight: 1,
    },
});
